import { Box, Typography, Button } from "@mui/material";
import CriSection from "../../components/CriSection";
import LichenPhoto from "../../assets/images/lichen/phaeophyscia.png";
import { useNavigate } from "react-router-dom";

const LichenFloraSection = () => {
  const navigate = useNavigate();

  const handleLearnMore = () => {
    navigate("/research/lichen");
  };

  return (
    <CriSection alternate={true}>
      <Box
        sx={{
          display: "flex",
          flexDirection: {
            xs: "column",
            md: "row",
          },
        }}
      >
        <Box
          sx={{
            marginRight: {
              xs: 0,
              md: "36px",
            },
            marginBottom: {
              xs: "12px",
              md: 0,
            },
            width: {
              xs: "100%",
              md: "400px",
            },
          }}
        >
          <img
            src={LichenPhoto}
            alt="Lichen"
            style={{
              width: "100%",
              height: "300px",
              borderRadius: "12px",
              objectFit: "cover",
            }}
          />
        </Box>

        <Box
          sx={{
            flexGrow: 1,
            flexBasis: 0,
          }}
        >
          <Typography
            sx={{
              fontSize: {
                xs: "28px",
                md: "36px",
              },
              fontWeight: 300,
              lineHeight: 1,
            }}
          >
            Lichens of the Southern Lake Michigan Region
          </Typography>

          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 300,
              lineHeight: 1.2,
              marginTop: "12px",
            }}
          >
            Gerould Wilhelm, Director of Research, continues his work on the
            lichens of the 53 counties that encompass the region around the
            southern end of Lake Michigan. This region consists of four states:
            Wisconsin (SE/SC), Illinois (NE/NC), Indiana (NW/NC), and Michigan
            (SW). In 1998, a flora of the 22-county Chicago region was
            presented, which indicated that the flora at the time was notably
            more depauperate than recent observations have shown. While the data
            are still being collected and analyzed, it seems that recent
            improvements in regional air quality have resulted in a positive
            response by lichenized fungi.
          </Typography>

          <Button
            onClick={handleLearnMore}
            variant="contained"
            sx={{
              marginTop: {
                xs: "24px",
                md: "12px",
              },
              padding: "8px 36px",
            }}
          >
            Learn More
          </Button>
        </Box>
      </Box>
    </CriSection>
  );
};

export default LichenFloraSection;
